import { render, staticRenderFns } from "./PaginationView.vue?vue&type=template&id=86f6013a&scoped=true&lang=pug&"
import script from "./PaginationView.vue?vue&type=script&lang=js&"
export * from "./PaginationView.vue?vue&type=script&lang=js&"
import style0 from "./PaginationView.vue?vue&type=style&index=0&id=86f6013a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f6013a",
  null
  
)

export default component.exports